<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>

    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :otherParams="{'taskType':1}"
        :columns="columns"
        :toolbar-config="toolbarConfig"
        :export-config="exportConfig"
        ref="grid"
    >
    </x-grid>

<!--    &lt;!&ndash;明细页表单简化通用写法&ndash;&gt;-->
<!--    <formModal title="产品宣传册" :visible="editModalVisible">-->
<!--      <detailForm :rowId="editRowId"-->
<!--                  v-if="editModalVisible"-->
<!--                  ref="detailForm"-->
<!--                  @cancelled="closeEdit()"-->
<!--                  @saved="closeEdit(true)">-->
<!--      </detailForm>-->
<!--    </formModal>-->
  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac, loadBaseCodeData,
} from "@/utils/common/XGridBase"
import {dataApi} from "@/services/clue/clueManage";

// import {dataApi} from "@/services/operate/MassSendCustomer";
// import detailForm from './leadsAssignedDetail'
// import { formatter as fmt } from "@/utils/ebase-formatter";
// import axios from "axios";
// import download from 'downloadjs';


//列表接口
// const url = api.operate.MASS_SEND_CUSTOMER;
const url = api.clue.DISTRIBUTE;


//主键
const rowId = 'assignId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("poolId", "公海线索ID", 160,'center'),
  fac.makeColumn("regionName", "经理部", 160,'center'),
  fac.makeColumn("dealerName", "经销商", 160,'center'),
  fac.makeColumn("assignedUserName", "销售顾问", 160,'center'),
  fac.makeColumn("assignorUserName", "分配人", 160,'center'),
  fac.makeColumn("assignDate", "分配时间", 200,'center'),
  fac.makeColumn("custName", "客户名称", 160,'center'),
  fac.makeColumn("phone", "手机号码", 160,'center'),
  fac.makeColumn("companyName", "公司名称", 160,'center'),
  fac.makeColumn("sourceName", "第三方来源系统", 160,'center'),
  fac.makeColumn("leadSourceName", "线索来源", 160,'center'),
  fac.makeColumn("strainName", "意向品系", 160,'center'),
  fac.makeColumn("brandName", "意向品牌", 160,'center'),
  fac.makeColumn("wantLevelName", "意向等级", 160,'center'),
  fac.makeColumn("wantCount", "预购数量", 160,'center'),
  fac.makeColumn("dealChanceName", "成交概率", 160,'center'),
  // fac.makeColumn({
  //   title: "操作",
  //   slots: {
  //     default: 'default'
  //   },
  //   align: 'center',
  //   width: 280,
  //   // fixed:'right'
  // }),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'poolId', title: "公海线索ID"},
  {field: 'assignorUserName'},
  {field: 'custName'},
  {
    field: 'assignDate',
    title: "分配时间",
    type: 'dateRange',
  },
  {field: 'phone'},
  {
    field: "strainId",
    title:"意向品系",
    type: "select",
    options: [],
  },//意向品系
  {
    field: "wantLevel",
    title: "意向等级",
    type: "select",
    options: [],
  },//意向等级
  {
    field: "regionId",
    title: "经理部",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    title: "经销商",
    type: "search-select",
    options: [],
  },
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: true,
  delData: false,
  addData: false,
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);
const popConfig = fac.makePopConfig(['checkResult']);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商

  this.wantLevelOptions = await loadBaseCodeData('CD200002')
  let strainData = await dataApi.getStrainList();
  //意向等级筛选下拉
  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    wantLevel: this.wantLevelOptions,
  });

  //意向品系筛选下拉
  this.strainOptions = strainData.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId,
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainId: this.strainOptions,
  })

  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    regionId: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    dealerName: this.dealerOptions,
  })
}

export default {
  mixins: [GridMixin],
  components: {
    // detailForm
  },
  watch: {
    $route: {
      handler: function (newValue, oldValue) {
        console.log(122, oldValue, newValue);
        if (oldValue && newValue.path === '/clue/leadsAssigned') {
          this.$nextTick(() => {
            this.refresh()
          })

        }
      },
      immediate: true,
    },
    'formData.regionId'(val) { //经理部 联动经销商
      console.log(val);
      this.formData.dealerName =null
      this.getDealerData(val)
    }
  },
  data() {
    return {
      wantLevelOptions:[],
      strainOptions: [],
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      popConfig,
      exportConfig: {
        remote: true,
        types: ['xlsx'],
        modes: ['all'],
      },
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
  }
}
</script>

<style scoped>
</style>
